
import DesignContentLayout from '@/layouts/design/DesignContentLayout';
import ReviewSort from '@/enums/ReviewSort';
import REVIEW_OPTION_TYPES from '@/constants/design/DUMMY_DATA';
import { mapMutations } from 'vuex';

export default {
  name: 'DesignComponentsControl',
  components: { DesignContentLayout },
  computed: {
    ReviewSort: () => ReviewSort
  },
  created() {
    this.STORE_RESPONSE_DATA({
      widget: {
        display_orders_in_use: [
          ReviewSort.RECENTLY_CREATED,
          ReviewSort.MOST_LIKES,
          ReviewSort.MOST_SCORES
        ]
      }
    });
    this.SET_REVIEW_SETTINGS({
      use_google_translation: true,
      use_translate_button: true
    });
    this.SET_REVIEW_OPTION_TYPES(REVIEW_OPTION_TYPES);
  },
  methods: {
    ...mapMutations('widget', ['STORE_RESPONSE_DATA']),
    ...mapMutations('reviewSettings', ['SET_REVIEW_SETTINGS']),
    ...mapMutations('reviewOptionTypes', ['SET_REVIEW_OPTION_TYPES'])
  }
};
